import { styled } from '@mui/system';

const stepperGray = '#6B6B6B';
const stepperBorder = '#e0e0e0';
const stepperButtonBg = '#f5f5f5';

export const StyledInputRoot = styled('div')(
  () => `
  font-family: 'IBM Plex Sans', sans-serif;
  font-weight: 400;
  color: ${stepperGray};
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: stretch;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid ${stepperBorder};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
`,
);

const BaseStyledInput = styled('input')(
  () => `
    box-sizing: border-box;
    font-family: inherit;
    font-weight: 500;
    color: ${stepperGray};
    background: white;
    border: none;
    border-radius: 0;
    outline: 0;
    min-width: 0;
    text-align: center;
    margin: 0;

    &:focus {
      outline: 0;
    }

    &:focus-visible {
      outline: 0;
    }
  `
);

const BaseStyledButton = styled('button')(
  () => `
    font-family: 'IBM Plex Sans', sans-serif;
    line-height: 1;
    box-sizing: border-box;
    border: none;
    border-radius: 0;
    background: ${stepperButtonBg};
    color: ${stepperGray};
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    padding: 0;
    margin: 0;
    align-self: stretch;
    min-height: 0;
    transition: background 120ms cubic-bezier(0.4, 0, 0.2, 1);
    -webkit-appearance: none;
    appearance: none;

    & svg {
      display: block;
      margin: auto;
    }

    &:hover {
      cursor: pointer;
      background: #ebebeb;
    }

    &:active {
      background: #e0e0e0;
    }

    &:focus-visible {
      outline: 0;
    }

    &.increment {
      order: 1;
    }
  `
);

export const LargeStyledButton = styled(BaseStyledButton)(
  () => `
    font-size: 0.875rem;
    width: 32px;
    min-width: 32px;
    flex-shrink: 0;
  `
)

export const SmallStyledButton = styled(BaseStyledButton)(
  () => `
    font-size: 0.75rem;
    width: 24px;
    min-width: 24px;
    flex-shrink: 0;
  `
)

export const LargeStyledInput = styled(BaseStyledInput)(
  () => `
    font-size: 0.875rem;
    width: 2.5rem;
    height: 32px;
    min-height: 32px;
    padding: 0 4px;
    line-height: 32px;
  `
)

export const SmallStyledInput = styled(BaseStyledInput)(
  () => `
    font-size: 0.75rem;
    width: 1.75rem;
    height: 24px;
    min-height: 24px;
    padding: 0 2px;
    line-height: 24px;
  `
)

